import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { UserService } from '@app/shared/services';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { EditMxPlayerComponent } from './edit-mx-player/edit-mx-player.component';
import { AddApiRapidValueService } from '../add-api-rapid-value.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-api-key-managed',
  templateUrl: './add-api-key-managed.component.html',
  styleUrls: ['./add-api-key-managed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddApiKeyManagedComponent implements OnInit, OnDestroy {
  @Input() currentFormId;
  subscription = new Subscription();
  showSearchBar = false;
  @Input() formName;
  @Input() mode;
  @Input() sharingMode;
  @Input() isRemoveEditSaveSharing;
  @Input() currentuserId;
  @Input() data;
  @Input() origin;
  @Input() connected_to_institution;
  apiManagerList = [];
  @Input() selectedFileList = [];
  allowEditPermission = true;
  @Input() isDataLoading = true;
  @Output() getUpdatedListAPiManager: EventEmitter<any> = new EventEmitter<any>();
  @Output() getNewImageEvent = new EventEmitter<string>();
  @Output() updateActionItemMx = new EventEmitter<boolean>();
  screenWidth: number;
  vaultStateObject;
  vaultStateObject$: any;
  resizeObservable$: Observable<Event>;
  constructor(
    private elementRef: ElementRef,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private userService: UserService,
    private vaultService: VaultStoreEffects,
    private dialog: MatDialog,
    private mxTaskbarService: MxTaskbarService,
    private MxconnectionService: MxconnectionService,
    private AddApiRapidValueService: AddApiRapidValueService
  ) {}
  ngOnDestroy(): void {
    this.AddApiRapidValueService.addEditMxAccountBalanceSubjectData.next(null);
    this.AddApiRapidValueService.mxAccountBalanceSubjectData.next(null);
    this.subscription?.unsubscribe();
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.showSearchBar = false;
    }
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );
  }
  getFormData(id) {
    if (this.vaultStateObject && this.vaultStateObject.forms) {
      return this.vaultStateObject.forms.filter((form) => form.id == id);
    }
  }
  editDataFeedDate() {
    const childDialog = this.dialog.open(EditMxPlayerComponent, {
      height: '100%',
      autoFocus: false,
      data: {
        selectedFileList: this.selectedFileList,
        currentuserId: this.currentuserId,
        currentFormId: this.currentFormId,
        formName: this.formName,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.AddApiRapidValueService.addEditMxAccountBalanceSubjectData.next(null);
          this.isDataLoading = true;
          this.getLinkedMXAccount();
          if (data.markCheck) {
            this.updateActionItemMx.emit(true);
          } else {
            this.updateActionItemMx.emit(false);
          }
        },
        (error) => {}
      )
    );
  }
  removelinkedForm(item) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Are you sure you want to remove file link ?',
        materialIcon: 'warning',
        text: ``,
        proceedTitle: 'Remove Link',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let fData = { guid: item.guid, vault_user_form_id: null };
          this.subscription.add(
            this.userService.updateUserLinkedForm(fData).subscribe((val) => {
              this.toastr.success('Form removed successfully.');
              this.selectedFileList = [];
              this.getUpdatedListAPiManager.emit({});
              this.getNewImageEvent.emit('');
              this.showSearchBar = false;
            })
          );
        }
      })
    );
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.subscription.add(
      this.AddApiRapidValueService.addEditMxAccountBalanceSubjectData.subscribe((data) => {
        if (data === 'addEditMxAccountBalanceData') {
          this.addEditMxAccountBalanceData();
        }
      })
    );
    this.getLinkedMXAccount();
  }
  mouseEnterHandler(event: MouseEvent, assetExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !assetExpansionPanel.expanded) {
      assetExpansionPanel.open();
    }
  }
  addInstitution() {
    // this.hidePopUp = true;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: { currentValutUserId: this.currentuserId },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        if (val.success) {
          this.getLinkedMXAccount();
        }
        this.cd.detectChanges();
      })
    );
  }

  getLinkedMXAccount() {
    this.subscription.add(
      this.MxconnectionService.getLinkedMXAccount(this.currentFormId).subscribe((res) => {
        this.selectedFileList = [];
        if (res) {
          this.selectedFileList.push(res);
          const allConnectedAccounts = this.selectedFileList.filter((item) => item?.connection_status?.toLowerCase() == 'connected');
          allConnectedAccounts.length > 0 ? this.AddApiRapidValueService.mxAccountBalanceSubjectData.next(allConnectedAccounts) : '';
        }
        this.isDataLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  addUserAccount(item) {
    let fData = { guid: item.guid, vault_user_form_id: this.currentFormId };
    if (item.vault_user_form_id) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '400px',
        data: {
          title: `Link ${item.name}?`,
          materialIcon: 'info',
          text: `${item.name} is currently linked to ${item.vaultUserForm.form_name}. Would you like to link it to ${this.formName} instead?`,
          proceedTitle: 'Yes, link it',
        },
      });
      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.deleteForm(fData);
          }
        })
      );
    } else {
      this.deleteForm(fData);
    }
  }
  deleteForm(fData) {
    this.subscription.add(
      this.userService.updateUserLinkedForm(fData).subscribe((val) => {
        this.toastr.success('Form linked successfully.');
        this.getNewImageEvent.emit('');
        this.getUpdatedListAPiManager.emit({});
        this.showSearchBar = false;
      })
    );
  }
  setCustomPosition() {
    var output = document.getElementById('add-api-key-managed-container').getBoundingClientRect();
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      eval(`document.getElementById('add-api-key-managed-search-box').style.top ='${+output.y.toFixed() + 78}px';`);
    }, 0);
  }
  addEditMxAccountBalanceData() {
    this.editDataFeedDate();
  }
}
